import f from "react";
import { toExcelData as N, excelColumns as D, createNumberRounder as R } from "./index.es170.js";
import "./index.es176.js";
import j from "./index.es177.js";
import "./index.es178.js";
import "./index.es179.js";
import "./index.es180.js";
import "./index.es181.js";
import "./index.es182.js";
import "./index.es183.js";
import k from "./index.es364.js";
const B = ({
  chartdata: d,
  isDecimal: r,
  filename: b,
  settings: v,
  title: g,
  dimensionLabels: t,
  buttonText: x,
  screenReaderText: l
}) => {
  const { primary: m, secondary: i, filters: a } = v, n = N(
    d,
    R(r),
    r
  ), s = t[m] || m, c = t[i] || i, $ = Object.keys(a).filter((e) => a[e]).map((e) => ({
    label: t[e] || e,
    value: a[e]
  })), h = c ? `${s} og ${c}` : s, p = $.map(({ label: e, value: o }) => `${e} er "${o}"`).join(" og "), u = [
    [{ value: g, fontWeight: "bold" }],
    [{ value: h }]
  ];
  p && u.push([{ value: p }]);
  const y = [
    ...u,
    ...n
  ], E = (e) => {
    e.preventDefault();
    const o = D(n);
    k(y, {
      columns: o,
      fileName: b
    });
  };
  return /* @__PURE__ */ f.createElement(
    j,
    {
      title: l,
      iconName: "download",
      onClick: E
    },
    x || "Last ned data (filtrert)",
    /* @__PURE__ */ f.createElement("span", { className: "bl-sr-only" }, l)
  );
};
export {
  B as default
};
//# sourceMappingURL=index.es277.js.map
